<template>
    <dashboard-layout title="채용관리" topBtn fullHeight>
        <template slot="topBtn">
            <recruitment-form @input="updateItem">
                <template #activator="{ attrs, on }">
                    <v-btn v-bind="attrs" v-on="on" color="secondary">채용공고 등록</v-btn>
                </template>
            </recruitment-form>
        </template>
        <template slot="contents">
            <recruitment-list-filter class="mb-4 mb-md-8" style="flex: 0 0 auto" />
            <template v-if="items?.length">
                <div class="v-cards">
                    <!-- S::채용리스트 item -->
                    <v-card v-for="item in items" :key="item._id" outlined rounded="lg">
                        <div class="pa-20 pa-md-24">
                            <v-row align="center" class="row--x-large">
                                <v-col cols="12" lg="" class="recruitment-item__detail mb-10 mb-lg-0">
                                    <h5 class="page-text--lg font-weight-medium mb-8 mb-lg-16">
                                        <a :href="`/recruitments/${item?._id}`" rel="noopener noreferrer"> {{ item?.subject }} </a>
                                    </h5>
                                    <v-chip-group v-if="item?.employment?.typesTexts" class="mb-4">
                                        <v-chip v-for="item in item.employment.typesTexts" :key="item" small outlined color="grey-d">
                                            <span class="grey-6--text">{{ item }}</span>
                                        </v-chip>
                                    </v-chip-group>
                                    <recruitment-list-item-application v-bind="{ item }" />
                                </v-col>
                                <v-col cols="12" md="9" lg="auto" class="mb-10 mb-md-0">
                                    <v-row class="row--large">
                                        <v-col cols="12" md="4" lg="auto" class="mb-4 mb-md-0">
                                            <recruitment-list-item-state v-bind="{ item }" v-on="{ put }" />
                                        </v-col>
                                        <v-col cols="12" md="8" lg="auto">
                                            <recruitment-list-item-counts v-bind="{ item }" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="3" lg="auto">
                                    <v-btn :to="`${$route.path}/${item?._id}/recruits`" outlined small block color="primary" class="mw-lg-100px mb-4 mb-lg-8">합격자관리</v-btn>
                                    <v-btn :to="`${$route.path}/${item?._id}/applications`" outlined small block color="primary" class="mw-lg-100px mb-4 mb-lg-8">모집현황(목록)</v-btn>
                                    <v-btn :to="`${$route.path}/${item?._id}/kanban`" outlined small block color="primary" class="mw-lg-100px mb-4 mb-lg-8">모집현황(칸반)</v-btn>
                                    <recruitment-form :value="item" @input="updateItem">
                                        <template #activator="{ attrs, on }">
                                            <v-btn v-bind="attrs" v-on="on" outlined small block color="grey-d" class="min-w-lg-100px">
                                                <span class="grey-6--text">공고수정</span>
                                            </v-btn>
                                        </template>
                                    </recruitment-form>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                    <!-- E::채용리스트 item -->
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else-if="$route.query.state">
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">채용공고가 없습니다.</p>
                </v-layout>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        등록된 채용공고가 없습니다.
                    </p>
                    <recruitment-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text height="auto" color="transparent" class="v-btn--column">
                                <i class="icon icon-plus-lg" />
                                <span class="mt-6 mt-lg-14 grey-9--text">채용공고 등록하기</span>
                            </v-btn>
                        </template>
                    </recruitment-form>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_STATES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import RecruitmentForm from "@/components/dashboard/company/recruitment/form/recruitment-form.vue";
import RecruitmentListFilter from "@/components/dashboard/company/recruitment-list-filter.vue";
import RecruitmentListItemState from "@/components/dashboard/company/recruitment-list-item-state.vue";
import RecruitmentListItemCounts from "@/components/dashboard/company/recruitment-list-item-counts.vue";
import RecruitmentListItemApplication from "@/components/dashboard/company/recruitment-list-item-application.vue";

export default {
    components: {
        DashboardLayout,
        RecruitmentForm,
        RecruitmentListFilter,
        RecruitmentListItemState,
        RecruitmentListItemCounts,
        RecruitmentListItemApplication,
    },
    data: () => ({
        loading: false,
        recruitments: [],

        limit: 10,
        summary: { totalCount: 0 },

        showsSearch: true,
    }),
    computed: {
        items() {
            return this.recruitments.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            if (!query.state) query.state = RECRUITMENT_STATES.ON_GOING.value;
            if (query.state == "ALL") delete query.state;

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, recruitments } = await api.v1.company.recruitments.gets({
                    headers: { skip, limit },
                    params,
                });

                this.recruitments = recruitments;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        async put(item) {
            this.loading = true;
            try {
                const { recruitment } = await api.v1.company.recruitments.put(item);
                this.updateItem(recruitment);
            } finally {
                this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.recruitments.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.recruitments.splice(index, 1, item);
            else {
                this.recruitments = [item, ...this.recruitments];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .recruitment-item__detail {
        max-width: calc(100% - 654px);
    }
}
@media (min-width: 1200px) {
}
</style>
